import type { Candle } from "../types";
import type { ChartOptions } from "../core/ChartOptions";
import type { Layout } from "../core/Layout";
import type { ThemeColors } from "../core/Theme";

// Everything a renderer needs for one paint pass.
export interface Frame {
  ctx: CanvasRenderingContext2D;
  L: Layout;
  candles: Candle[];
  start: number;
  end: number;
  startFrac: number; // fractional index at the left plot edge
  endFrac: number;   // fractional index at the right plot edge (> N-1 = empty future space)
  count: number;
  candleW: number;
  bodyW: number;
  minP: number;
  maxP: number;
  x: (index: number) => number;
  y: (price: number) => number;
  priceAt: (y: number) => number;
  indexAt: (x: number) => number;
  fracIndexAt: (x: number) => number;
  xt: (time: number) => number; // epoch time → pixel (time-anchored drawings)
  timeAt: (x: number) => number; // pixel → epoch time (fractional between candles)
  step: number; // avg candle duration (s)
  opts: ChartOptions;
  tc: ThemeColors;
}

export function polyline(f: Frame, values: (number | null)[], yOf: (v: number) => number) {
  const { ctx } = f;
  ctx.beginPath();
  let started = false;
  for (let i = Math.max(0, f.start); i <= f.end; i++) {
    const v = values[i];
    if (v == null || !isFinite(v)) { started = false; continue; }
    const px = f.x(i), py = yOf(v);
    if (!started) { ctx.moveTo(px, py); started = true; } else ctx.lineTo(px, py);
  }
  ctx.stroke();
}
